import _styled from "styled-components";
export var ReversedItemsWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "buttonstyled__ReversedItemsWrapper",
  componentId: "sc-vxo3fk-0"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(28 28 51 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem"
});
export var notificationIndicatorStyles = {
  "display": "grid",
  "height": "1.5rem",
  "width": "1.5rem",
  "placeItems": "center",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(204 0 34 / var(--tw-bg-opacity))",
  "fontSize": "0.875rem !important",
  "lineHeight": "1.25rem !important",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(250 250 250 / var(--tw-text-opacity))"
};
export var StyledButtonNotificationIndicator = /*#__PURE__*/_styled.span.withConfig({
  displayName: "buttonstyled__StyledButtonNotificationIndicator",
  componentId: "sc-vxo3fk-1"
})(["", " ", ""], notificationIndicatorStyles, {
  "position": "absolute",
  "top": "-0.5rem",
  "right": "-0.5rem"
});